import { useContentSelector } from '@wajeez-web/stores/content';

export const useComponentComponentsLookups = () => {
  return useContentSelector(
    ({ components }) => components.componentComponentLookups
  );
};

export const useGetComponentByIdMultilingual = () => {
  return useContentSelector(({ components }) => components.byIdMultilingual);
};

export const useCreateComponentByTypeIdMultilingual = () => {
  return useContentSelector(({ components }) => components.createMultilingual);
};

export const useEditComponentMultilingual = () => {
  return useContentSelector(({ components }) => components.editMultilingual);
};
